import '../App.css';

const NavBar = () => (
  <nav className="navBar">
    <h1>FREE-TO-PLAY GAMES LIST</h1>
    <a href="/" id="home">HOME</a>
  </nav>
);

export default NavBar;
